export const SIZE_MEDIUM = 1025
export const SIZE_SMALL = 768
export const SIZE_SMALLER = 576

export const mediumScreen = `screen and (max-width: ${SIZE_MEDIUM}px)`
export const smallAndSmaller = `screen and (max-width: ${SIZE_SMALL}px)`
export const smallerScreen = `screen and (max-width: ${SIZE_SMALLER}px)`
